import { defineStore } from 'pinia'

export const useGlobalStore = defineStore('global', {
  state: () => {
    // Load autoCollapseEnabled from localStorage, default to true if not set
    const savedAutoCollapse = localStorage.getItem('autoCollapseEnabled')
    const autoCollapseEnabled = savedAutoCollapse !== null ? savedAutoCollapse === 'true' : true // Default to true if not set

    return {
      isSidebarMinimized: false,
      autoCollapseEnabled,
    }
  },

  actions: {
    toggleSidebar() {
      this.isSidebarMinimized = !this.isSidebarMinimized
    },
    toggleAutoCollapse() {
      this.autoCollapseEnabled = !this.autoCollapseEnabled
      // Persist to localStorage
      localStorage.setItem('autoCollapseEnabled', String(this.autoCollapseEnabled))
    },
  },
})
